/**
 * Self-contained demo mode.
 * Lets anyone experience the full emotion naming loom + spaced repetition artifact
 * without creating a real loom. Perfect for landing page "try the loom" and for
 * development when the Worker is not running.
 */
import type { Thread } from './types'
import { nanoid } from 'nanoid'

const DEMO_EMOTIONS = [
  'split-root vigilance', 'transcript armor', 'office-hour debt',
  'family translator mask', 'proof burden', 'code-switch fatigue',
  'belonging debt', 'first-at-the-table weight', 'hypervigilance hangover'
]

const DEMO_NOTES = [
  'Every time I walk into the building I do a quick scan of who else looks like they might be the only one.',
  'I spent 40 minutes rewriting an email because I was afraid it sounded too direct for someone like me.',
  'When my mom calls during study hours the guilt is so loud I can’t read the next sentence.',
  'I keep waiting for someone to notice I don’t actually know the rules everyone else seems born knowing.',
  'After the group project meeting I sat in my car for twenty minutes just to stop performing.',
  'I said “I’m fine” when they asked how the visit home was. I wasn’t fine. I was translating the entire time.',
  'The scholarship thank-you note took me three days. I kept worrying they would see through me.',
]

export function generateDemoThreads(count = 7): Thread[] {
  const now = Date.now()
  return Array.from({ length: count }).map((_, i) => {
    const frag = 4.5 + Math.random() * 4.8
    const recovery = 5.2 + Math.random() * 4.1
    const readiness = 3.2 + Math.random() * 5.5
    const clarity = 3.8 + Math.random() * 4.4

    return {
      id: 'demo_' + nanoid(8),
      loomId: 'demo',
      emotionName: DEMO_EMOTIONS[i % DEMO_EMOTIONS.length],
      note: DEMO_NOTES[i % DEMO_NOTES.length],
      frag: Math.round(frag * 10) / 10,
      recovery: Math.round(recovery * 10) / 10,
      readiness: Math.round(readiness * 10) / 10,
      clarity: Math.round(clarity * 10) / 10,
      createdAt: new Date(now - (count - i) * 1000 * 60 * 37).toISOString(),
      cycle: Math.floor(i / 3) + 1,
    }
  })
}

export const DEMO_LOOM_TITLE = 'Apartment 3B — Fall First-Gens'
